import {handleOtherResponseCode, Logout, REDIRECT, signOut, SUCCESS_REPONSE_CODE, toastr, 
        UNPROCESSABLE_ENTITY_RESPONSE_CODE, Url, CustomToastrAction, WebsiteCookies} from '@/imports-files/pages/admins/logout';

export async function logoutUser(router, userType)
{
    const websiteCookies = new WebsiteCookies();
  // TODO the clearJobFilter is not working because of import----------
  // ----------- Replace this with that -------------------------
    localStorage.removeItem('jobFiltersData');
    localStorage.removeItem('dataTableFiltersData');
    localStorage.removeItem('navbarStatus');
    localStorage.removeItem('userData');
    localStorage.removeItem('jobs_toggle');
    websiteCookies.deleteAllCookies();
  // ------------------------------------------------------------------

  const result              =  await new Logout().signOutUser();
  const status_code         =  result.status || result.response.status;
  const customToastrAction  =  new CustomToastrAction(); 

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      const response = result.data;
      if (response.success) 
      {
        let host   =  Url(process.env.NEXT_PUBLIC_BASE_URL).host
        const user_url = setLogoutUrl(userType);
        const callBackUrl = window.location.protocol + '//' + host + user_url;
        await signOut({
          callbackUrl: callBackUrl
        })
      }
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE: 
        customToastrAction.setNormalToastr(result.response.data.error, 'warning');
        // toastr.warning(result.response.data.error);
        const callBackUrl = ( userType == "account_owner" || userType == "ClientAdmin" || userType == "ClientUser" || userType == "client_user" || userType == "client_admin" || userType == "reviewer") ? REDIRECT.client.login : REDIRECT.admins.login
        await signOut({
          callbackUrl: callBackUrl
        })
      break;
    default:
      handleOtherResponseCode(status_code, router)
  }
}

export function setLogoutUrl(userType)
{
  if (userType == "account_owner" || userType == "ClientAdmin" || userType == "ClientUser" || userType == "client_user" || userType == "client_admin" || userType == "reviewer")
  {
    return REDIRECT.client.login
  }
  else if (userType == 'AgencyUser')
  {
    return REDIRECT.agency.welcome;
  }
  else {
    return REDIRECT.admins.login
  }
}

